import React from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import Input from '@tencent/dui/lib/components/Input';
import { ModalFooter, ModalTitle } from '../../index';
import i18n from 'i18next';
import styles from './theme-edit-custom-dialog.less';
import {
    ThemePreviewExample,
} from './theme-preview-example';
import {
    IHandleColorChangeProps,
    ThemeColorConfig,
} from './theme-color-config';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import cloneDeep from 'lodash/cloneDeep';

interface IEditCustomThemeDialogProps {
    visible: boolean;
    isCreateTheme: boolean;
    themeId?: string;
    themeItem: IThemeSelectItem;
    onOk(props: IThemeSelectItem);
    onCancel();
    updateThemeItem(themeItem: IThemeSelectItem);
}

const DEFAULT_TITLE = '自定义';

interface IThemeEditCustomDialogState {
    title?: string;
}

export class ThemeEditCustomDialog extends React.Component<IEditCustomThemeDialogProps, IThemeEditCustomDialogState> {
    // static getDerivedStateFromProps(nextProps) {
    //     if (!nextProps.isCreateTheme) {
    //         return {
    //             title: nextProps.themeItem.title,
    //         };
    //     }
    // }

    constructor(props: IEditCustomThemeDialogProps) {
        super(props);
        if (props.isCreateTheme) {
            this.state = {
                title: undefined,
            };
        } else {
            this.state = {
                title: props.themeItem.title,
            };
        }
    }

    render() {
        return <Modal
            destroyOnClose={true}
            className={styles['custom-theme-modal-container']}
            visible={this.props.visible}
            zIndex={9999}
            mask={true}
            maskStyle={{
                background: 'transparent',
            }}
            onCancel={this.props.onCancel}
            title={<ModalTitle
                title={i18n.t('创建自定义颜色')}
            />}
            footer={<ModalFooter
                disabledOk={false}
                onCancel={this.props.onCancel}
                onOk={() => {
                    if (this.props.themeItem) {
                        const title = this.state.title?.trim();
                        const themeItem = {
                            ...this.props.themeItem,
                            title: title || DEFAULT_TITLE,
                        };
                        this.props.onOk(themeItem);
                    }
                }} />}
        >
            <div className={styles['custom-theme-dialog-content-container']}>
                <div className={styles['custom-theme-dialog-title-wrapper']}>
                    <div className={styles['custom-theme-dialog-title-label']}>
                        { i18n.t('名称') }
                    </div>
                    <Input
                        maxLength={10}
                        value={this.state.title}
                        placeholder={i18n.t('自定义')}
                        onChange={(title) => {
                            this.setState({
                                title,
                            });
                        }}
                        inputClassName={styles['custom-theme-dialog-title-input']}
                        style={{
                            width: '100%',
                        }}
                    />
                </div>
                <div className={styles['custom-theme-dialog-content-wrapper']}>
                    <ThemePreviewExample themeConfig={this.props.themeItem} />
                    <ThemeColorConfig
                        themeConfig={this.props.themeItem}
                        handleColorChange={this.handleColorChange}
                    />
                </div>
            </div>
        </Modal>;
    }

    private handleColorChange = (props: IHandleColorChangeProps) => {
        const { key, color } = props;
        const newThemeItem = cloneDeep(this.props.themeItem);
        newThemeItem.colorSchema[key].color = color;
        this.props.updateThemeItem(newThemeItem);
    };
}
